import { action } from 'mobx';
import { API } from 'aws-amplify';
import { FurtherConsiderations } from '../models';

export class FurtherConsiderationsStore {
  @action loadFurtherConsiderations(): Promise<FurtherConsiderations> {
    console.log('*************** loading further considerations ************************');
    return API.get('restAPI', '/furtherConsiderations', {}).then(considerations => {
      console.log(considerations);
      return FurtherConsiderations.createFromConsiderations(considerations);
    }).catch((error) => {
      console.error(error);
      // REJECT rather than `return error`. Returning made the promise RESOLVE
      // with an Error object, which the caller then stored as if it were a
      // FurtherConsiderations — so the next findConsiderations() call threw a
      // TypeError instead of degrading to "no considerations". Rejecting hands
      // control to the rejection handler the entry store already has, and lets
      // it avoid caching a failed load.
      throw error;
    });
  }
}